import React from "react";

import { isPortrait, isLandscape } from "@/modules/commonMobile";

import img_video_off from "@/assets/img/v2icons/img_video_off.svg";
import img_video_loading from "@/assets/img/img_video_loading.png";

import "./index.scss";

import { ILanguageType } from "@/types/GlobalTypes";

interface IProps {
	enableStreaming: boolean;
	isLoadingStreaming: boolean;

	langdata: ILanguageType;

	//Only for mobile
	isBetClosed?: boolean;
	showHugeStreaming?: boolean;

	isDesktop?: boolean;
}

export default class VideoOffNotice extends React.PureComponent<IProps> {
	render() {
		const { langdata } = this.props;

		const portraitCheck = (
			(isPortrait() && this.props.isBetClosed) ||
			isLandscape()
		);

		return (
			<div className={"video-off-notice-container" +
				(this.props.enableStreaming ? " has-streaming" : " no-streaming") +
				(portraitCheck && this.props.isLoadingStreaming ? " is-loading" : " loaded") +
				(this.props.showHugeStreaming ? " hugestreaming" : "")
				}>
				
				{
					!this.props.enableStreaming ? (
						this.props.isDesktop ? (
							<div>
								<img src={img_video_off} alt="video off" />
								
								<br />
								<div style={{whiteSpace: "pre"}}>
									{langdata["txt_video_is_off_desktop_message"]}
								</div>
							</div>
						) : (
							<div>
								<img src={img_video_off} alt="video off" />
								
								<br />
					
								<div>
									{langdata["txt_video_is_off_mobile_message"]}
								</div>
							</div>
						)
					) : null
				}
	
				{
					portraitCheck &&
					this.props.enableStreaming &&
					this.props.isLoadingStreaming ?
					<div className="loading-text">
						<img src={img_video_loading} alt="loading" />
						<div>
							{langdata["txt_loading_video"]}
						</div>
					</div> : null
				}
			</div>
		);
	}
}